import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "products-area ptb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-9 order-2 order-lg-1" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "products-single-item transition-y" }
const _hoisted_7 = { class: "product-img position-relative z-1" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["onClick", "disabled"]
const _hoisted_10 = { class: "border-style" }
const _hoisted_11 = { class: "product-content" }
const _hoisted_12 = { class: "ps-0 list-unstyled d-flex review" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "col-lg-12" }
const _hoisted_15 = { class: "pagination-area text-center mt-0" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SidebarWidget = _resolveComponent("SidebarWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "section-title mw-860" }, [
        _createElementVNode("span", { class: "top-title" }, "المتجر"),
        _createElementVNode("h2", null, "اختر اشتراكك المناسب")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.id,
                class: "col-xl-4 col-md-6"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_RouterLink, {
                      to: `/product-details/${product.id}`,
                      class: "d-block"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: product.image,
                          alt: product.name
                        }, null, 8, _hoisted_8)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("a", {
                      class: "btn",
                      onClick: ($event: any) => (_ctx.addToCart(product)),
                      disabled: _ctx.isInCart(product.id)
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.isInCart(product.id) ? "في السلة" : "إضافة إلى السلة"), 1)
                    ], 8, _hoisted_9)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                        return _createElementVNode("li", { key: star }, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "ri-star-s-fill" }, null, -1)
                        ]))])
                      }), 64))
                    ]),
                    _createElementVNode("h3", null, [
                      _createVNode(_component_RouterLink, {
                        to: `/product-details/${product.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("h4", null, [
                      (product.oldPrice)
                        ? (_openBlock(), _createElementBlock("del", _hoisted_13, _toDisplayString(product.oldPrice) + " €", 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(product.price) + " € ", 1)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                  class: "next page-numbers",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1)
                ]))], 8, _hoisted_16),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: page,
                    class: _normalizeClass(["page-numbers", { current: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_17))
                }), 128)),
                _createElementVNode("span", {
                  class: "next page-numbers",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
                ]))], 8, _hoisted_18)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_SidebarWidget)
        ])
      ])
    ])
  ]))
}